import { styled, alpha, Theme, CSSObject } from '@mui/material/styles';

import { Box, Button as MuiButton, Grid as MuiGrid } from '@mui/material';
import { SvgIconWrapProps } from '../';

export const StyledIconWrap = styled('div')<SvgIconWrapProps>(({ theme, width, height, radius, hover }) => ({
  ...(width && {
    width: width,
  }),
  ...(height && {
    height: height,
  }),
  display: `inline-flex`,
  alignItems: `center`,
  ...(hover &&
    {
      // backgroundColor: `red`
    }),
}));

// export const StyledIconWrap = styled('div')(({ theme }) => ({
//   display: `inline-flex`,
//   alignItems: `center`,
//   // backgroundColor: theme.palette.default.black,
// }));

// export const StyledIconWrap = styled("span")``;
//
// display: inline-flex;
// align-items: center;
// justify-content: center;
// outline: 1px solid red;
// width: ${(props) => (props.width ? props.width : 16)}px;
// height: ${(props) => (props.height ? props.height : 16)}px;
// border-radius: ${(props) => (props.radius ? props.radius : 0)}px;
// background-color: ${(props) => (props.bgColor ? props.theme.palette[props.bgColor].main : props.theme.palette.grayscale[400])};
//

// export const StyledIconWrap = styled(MuiGrid, {
//   shouldForwardProp: (prop) => !['width', 'height', 'hover', 'radius'].includes(String(prop)),
// })<SvgIconWrapProps>(({ theme, hover, }) => ({
//   // ...(hover && {
//   //   backgroundColor: alpha(theme.palette.secondary.main, 0.08),
//   // }),
// }))
